import React from 'react';
import { CustomIcon } from '../UI';
import { Pagination } from '../pagination';
import Item from './item';
import Loading from '../loading-animation';
import './ItemList.scss';

const ItemList = ({
  items,
  itemType, // 'loads', 'users', 'customers', 'payments'
  selectedItems,
  onSelectAll,
  onSelectItem,
  onToggleExpand,
  onDeleteSelected,
  onEdit,
  onViewFiles,
  onChangeStatus,
  canSelect = true,
  canDelete = true,
  canEdit = true,
  canChangeStatus = true,
  canDuplicate = true,
  currentPage,
  onPageChange,
  columns, // Array of column definitions
  itemsPerPage = 10,
  totalItems,
  isServerPaginated = false,
  loading = false
}) => {
  const totalItemsCount =
    typeof totalItems === 'number' ? totalItems : items.length;

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedItems = isServerPaginated
    ? items
    : items.slice(startIndex, endIndex);
  const pageItemIds = paginatedItems.map((item) => item._id || item.id);
  const isAllSelected =
    paginatedItems.length > 0 &&
    pageItemIds.every((id) => selectedItems.includes(id));
  const isIndeterminate =
    pageItemIds.some((id) => selectedItems.includes(id)) && !isAllSelected;


  const renderHeader = () => {
    if (!columns || columns.length === 0) return null;

    return (
      <div className="table-header">
        <div className={`header-row ${itemType}`}>
          <div className="header-checkbox">
            {canSelect && (
              <input
                type="checkbox"
                checked={isAllSelected}
                ref={(input) => {
                  if (input) input.indeterminate = isIndeterminate;
                }}
                onChange={() => onSelectAll(pageItemIds)}
                className="header-checkbox-input"
              />
            )}
          </div>
          {columns.map((col, index) => {
            // Special handling for actions column (without delete button)
            if (col.key === 'actions') {
              return (
                <div key={index} className={`header-${col.key}`}>
                  <span className="actions-label">{col.label || 'Actions'}</span>
                </div>
              );
            }
            return (
              <div key={index} className={`header-${col.key}`}>
                {col.label}
              </div>
            );
          })}
          {/* Separate delete column */}
          <div className="header-delete">
            {canDelete && selectedItems.length > 0 && (
              <button
                type="button"
                className="delete-selected-btn"
                onClick={onDeleteSelected}
                title={`Delete ${selectedItems.length} selected items`}
              >
                <CustomIcon name="trash-03" size={24} />
              </button>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={`item-list-table ${itemType}`}>
      {renderHeader()}

      {/* Items List */}
      <div className="items-list">
        {loading ? (
          <div className="loading-state">
            <Loading size="medium" />
          </div>
        ) : paginatedItems.length > 0 ? (
          paginatedItems.map((item) => {
            const itemId = item._id || item.id;
            return (
              <Item
                key={itemId}
                item={item}
                itemType={itemType}
                isSelected={selectedItems.includes(itemId)}
                onSelect={onSelectItem}
                onToggleExpand={onToggleExpand}
                onDelete={() => onDeleteSelected([itemId])}
                onEdit={onEdit}
                onViewFiles={onViewFiles}
                onChangeStatus={onChangeStatus}
                canSelect={canSelect}
                canDelete={canDelete}
                canEdit={canEdit}
                canChangeStatus={canChangeStatus}
                canDuplicate={canDuplicate}
                expanded={item.expanded}
                toggleData={item.details || item.toggleInfo}
              />
            );
          })
        ) : (
          <div className="empty-state">
            <CustomIcon name="cube" size={48} color="gray-40" />
            <h3>No items found</h3>
            <p>Try adjusting your search or filter criteria</p>
          </div>
        )}
      </div>

      {/* Pagination */}
      <Pagination
        currentPage={currentPage}
        totalItems={totalItemsCount}
        itemsPerPage={itemsPerPage}
        onPageChange={onPageChange}
      />
    </div>
  );
};

export default ItemList;

